<div
  class="tabs"
  [ngClass]="{
    'secondary-bg': type,
    'modal-tabs': type === TabTypeEnum.Modal,
    'tabs--modern': appearance === 'modern'
  }"
>
  <nav class="d-flex tabs-navegacao" [ngClass]="position">
    <ng-container
      *ngFor="let tab of tabs; let i = index"
      class="d-flex justify-space-evenly navegacao-container container"
    >
      <a
        *ngIf="type === TabTypeEnum.Link || !type"
        class="d-flex justify-center align-center container-label"
        [ngClass]="{
          'secondary-bottom-border': !!type,
          'render-tab-active': currentTab === tab.id
        }"
        (click)="currentTab = tab.link || ''"
        [routerLink]="[tab.link, mode]"
        queryParamsHandling="preserve"
        routerLinkActive="active"
      >
        <ng-container *ngIf="tab?.icon">
          <app-svg-icon
            class="mr-5"
            [src]="tab.icon?.url || ''"
            [width]="tab.icon?.width"
            [height]="tab.icon?.height"
            [color]="tab.icon?.color || 'black'"
          ></app-svg-icon>
        </ng-container>
        {{ tab.title }}
      </a>

      <a
        *ngIf="type === TabTypeEnum.Render"
        class="d-flex justify-center align-center container-label secondary-bottom-border"
        [ngClass]="{ 'render-tab-active': currentTab === tab.id }"
        role="button"
        tabindex="0"
        (click)="changeTab(tab.id)"
        (keydown.enter)="changeTab(tab.id)"
        (keydown.space)="changeTab(tab.id)"
      >
        <ng-container *ngIf="tab?.icon">
          <app-svg-icon
            class="mr-5"
            [src]="tab.icon?.url || ''"
            [width]="tab.icon?.width"
            [height]="tab.icon?.height"
            [color]="tab.icon!.color"
          ></app-svg-icon>
        </ng-container>
        {{ tab.title }}
      </a>

      <a
        *ngIf="type === TabTypeEnum.Modal"
        class="d-flex justify-center align-center container-label secondary-bottom-border"
        [ngClass]="{
          'render-tab-active': currentTab === tab.id,
          'multiple-tabs': tabs.length > 4,
          'container-label--closable': !!tab.icon?.action
        }"
        role="button"
        tabindex="0"
        (click)="changeTab(tab.id)"
        (keydown.enter)="changeTab(tab.id)"
        (keydown.space)="changeTab(tab.id)"
        routerLinkActive="active"
      >
        <ng-container *ngIf="tab?.icon">
          <app-svg-icon
            class="mr-5 {{ tab?.icon?.class }}"
            [ngClass]="{ hidden: tab.icon!.action && currentTab !== tab.id }"
            [src]="tab.icon?.url || ''"
            [width]="tab.icon?.width"
            [height]="tab.icon?.height"
            [color]="tab.icon!.color"
            (click)="tab.icon!.action && deleteTab(tab)"
          ></app-svg-icon>
        </ng-container>
        {{ tab.title }}

        <ng-container *ngIf="tab?.open && currentTab === tab.id">
          <div
            class="selection d-flex direction-column"
            
          >
            <div
              *ngFor="let product of products"
              class="selection-product row align-center justify-center"
              role="button"
              tabindex="0"
              (click)="insertProduct(product)"
              (keydown.enter)="insertProduct(product)"
              (keydown.space)="insertProduct(product)"
            >
              <span class="product-text">{{ product.Name }}</span>
            </div>
          </div>
        </ng-container>
      </a>
    </ng-container>
  </nav>
</div>
